import angular from 'angular';
import { isNil } from 'lodash';

import {} from './od-header.less';

module.exports = angular.module('market.components.od-header', [])
.component('odHeader', {
  bindings: {
    logoOnly: '<?',
  },
  template: require('./od-header.jade')(),
  controller: class {
    constructor($rootScope, $scope, $state, $mediaQuery, Lead, Segment) {
      this.showLogoOnly = isNil(this.logoOnly) ? false : this.logoOnly;
      this.session = $rootScope.session;
      this.$state = $state;
      this.$mediaQuery = $mediaQuery;
      this.Segment = Segment;
      if ((this.session || {}).logged_in) {
        this.leads = Lead.query();
      }
    }

    firstName() {
      if (this.session && this.session.human && this.session.human.full_name) {
        return this.session.human.full_name.split(/\s+/)[0];
      }
      return '';
    }

    trackOpendorMortgageLink(){
      this.Segment.track('clicked mortgage link', {
        page: 'homepage', pageLocation: 'header'
      });
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-header.js
 **/